import { createSlice } from "@reduxjs/toolkit"

import { adminManageUserStatus } from "../api/api"


const initialState={
   loading:false,
   error:{}, 
   response: null

}

const adminManageUserStatusSlice= createSlice({
    name:'adminManageUserStatus',
     initialState,

     reducers:{

     },

     extraReducers: (builder)=>{
        builder.addCase( adminManageUserStatus.pending, (state)=>{
            state.loading = true
            state.error={}
            state.response =null

        })

        builder.addCase( adminManageUserStatus.rejected, (state, action)=>{
            state.loading=false
            state.error= action.payload
            state.response=null
        }

        )
        builder.addCase( adminManageUserStatus.fulfilled, (state, action)=>{
            state.loading=false
            state.error={}
            state.response= action.payload
        }
            )


     }

})

export default adminManageUserStatusSlice.reducer